"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areCommentsEqual = exports.atEndOfComment = void 0;
var Text_1 = require("ContentTokens/Models/Text");
var lodash_1 = __importDefault(require("lodash"));
var Utils_1 = require("../Utils");
var CommentMark_1 = require("Project/QwilrEditor/Comments/CommentMark");
var atEndOfComment = function (mark, point, editor) {
    var nextTextEntry = (0, Utils_1.getNext)(editor, point.path, Text_1.Text.isText);
    return !nextTextEntry || !hasComment(nextTextEntry[0].marks, mark);
};
exports.atEndOfComment = atEndOfComment;
var areCommentsEqual = function (mark1, mark2) {
    return CommentMark_1.CommentMark.isComment(mark1) && lodash_1.default.isEqual(mark1, mark2);
};
exports.areCommentsEqual = areCommentsEqual;
function hasComment(marks, mark) {
    return marks.some(function (m) { return (0, exports.areCommentsEqual)(mark, m); });
}
